import { DOWNLOAD_SERVER, FILE_SERVER } from '@/api/modules/files';
import { Modal } from 'iview';

export const getImageSrc = imageInfo => {
    if (imageInfo) {
        const file = JSON.parse(imageInfo);
        if (file && file.hasOwnProperty('name') && file.hasOwnProperty('url') && file.url) {
            return FILE_SERVER + file.url;
        }
    }

    return '';
};

export const singleImageRender = (h, imageInfo, config = null) => {
    const setting = Object.assign({
        doubleClick: true,
        width: '30px',
        height: '30px'
    }, config);

    const imgElement = [];
    const imageSrc = getImageSrc(imageInfo);
    if (imageSrc !== '') {
        const img = {
            domProps: {
                src: imageSrc
            },
            style: {
                width: setting.width,
                height: setting.height,
                marginTop: '4px',
                cursor: 'pointer'
            },
            on: {
                click: function () {
                    if (setting.doubleClick) {
                        Modal.info({
                            title: '图片信息',
                            render: h => {
                                return h("img", {
                                    attrs: {
                                        src: imageSrc,
                                        style: "width: 370px;height: 370px;"
                                    }
                                });
                            }
                        });
                        // window.open(imageSrc);
                    }
                }
            }
        };

        imgElement.push(h('img', img));
    }

    return h('div', imgElement);
};


export const getUploadImageSrc = imageInfo => {
    if (imageInfo) {
        const file = JSON.parse(imageInfo);
        if (file && file.hasOwnProperty('name') && file.hasOwnProperty('url') && file.url) {
            return FILE_SERVER + 'upload/' + file.url;
        }
    }

    return '';
};

export const singleImageUploadRender = (h, imageInfo, config = null) => {
    const setting = Object.assign({
        doubleClick: true,
        width: '30px',
        height: '30px'
    }, config);

    const imgElement = [];
    const imageSrc = getUploadImageSrc(imageInfo);
    if (imageSrc !== '') {
        const img = {
            domProps: {
                src: imageSrc
            },
            style: {
                width: setting.width,
                height: setting.height,
                marginTop: '4px',
                cursor: 'pointer'
            },
            on: {
                click: function () {
                    if (setting.doubleClick) {
                        Modal.info({
                            title: '图片信息',
                            render: h => {
                                return h("img", {
                                    attrs: {
                                        src: imageSrc,
                                        style: "width: 370px;height: 370px;"
                                    }
                                });
                            }
                        });
                        // window.open(imageSrc);
                    }
                }
            }
        };

        imgElement.push(h('img', img));
    }

    return h('div', imgElement);
};
